module.exports = __webpack_public_path__ + "img/customer.c28fb249.png";